import { ArticleUiIcon } from '@/components/icons/article-ui-icon'

import { ListicleCardCopy } from './listicle-card-copy'
import { ListicleCardCta } from './listicle-card-cta'
import { ListicleCardHeading } from './listicle-card-heading'
import { ListicleCardImage } from './listicle-card-image'
import type { ListicleCardProps } from './types'

export const ListicleCard = ({ card, text }: ListicleCardProps) => (
  <div
    {...card.editorAttributes}
    className="listicle-card group relative w-full max-w-[806px] py-3 first-of-type:pt-0"
    data-track-impression
    data-event-name="listicle-card"
    data-event-product={card.resolvedReleaseSlug || card.name}
    data-event-position={String(card.index)}
    data-event-listicle-position={String(card.index)}
  >
    <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-8 shadow-lg">
      <a
        href={`#${card.anchorId}`}
        data-tracking="ignore"
        className="absolute top-4 right-4 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-500 transition-colors hover:bg-slate-200 hover:text-slate-700"
        aria-label={text.jumpToSection}
      >
        <ArticleUiIcon id="chevron-down" viewBox="0 0 24 24" className="h-5 w-5" />
      </a>
      <ListicleCardHeading card={card} text={text} />
      <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
        <ListicleCardImage card={card} text={text} />
        <div className="flex flex-col justify-between md:col-span-7">
          <ListicleCardCopy card={card} text={text} />
          <ListicleCardCta card={card} text={text} />
        </div>
      </div>
    </div>
  </div>
)
